import type { DevicePackageKey } from '../constants/devicePackages'
import type { VersionOption } from './version'

export interface Device {
    id: string
    type: number | null
    lng: number | null
    lat: number | null
    address: string
    name: string | null
    remark: string | null
    status: number | null
    status_changed_at?: string | null
    created_at: string
    last_active_at: string | null
    last_image_uploaded_at?: string | null
    lure_remind_at: string | null
    package_key: DevicePackageKey | string
    purchase_version?: string | null
    installation_image_path?: string | null
    cloud_service_expires_at?: string | null
    cloud_service_status?: 'unknown' | 'normal' | 'expiring' | 'overdue'
    region_id: number | null
    project_id: number | null
    project_name?: string | null
    root_project_name?: string | null
    capability_keys?: string[]
    latest_environment?: EnvironmentSample | null
}

export type EnvironmentSampleStatus = 'ok' | 'suspect' | 'communication_error'

export interface EnvironmentSample {
    report_id: string
    sampled_at: string
    received_at: string
    temperature_c: number | null
    humidity_percent: number | null
    co2_ppm: number | null
    status: EnvironmentSampleStatus
    warnings: string[]
    error?: string | null
}

export interface PaginatedDeviceResponse {
    page: number
    page_size: number
    total: number
    items: Device[]
}

export interface DeviceFilterOptionsResponse {
    names: string[]
    project_names: string[]
    region_ids: number[]
    project_ids: number[]
    export_project_options?: DeviceExportProjectOption[]
    purchase_versions: string[]
    purchase_version_options?: VersionOption[]
}

export interface DeviceExportProjectOption {
    id: number
    label: string
    parent_id?: number | null
}

export const DEVICE_PURCHASE_VERSION_UNSET_FILTER = '__unset__'

export interface DeviceQueryParams {
    page?: number
    page_size?: number
    search_name?: string
    project_ids?: number[]
    region_ids?: number[]
    status?: 'all' | 'online' | 'offline'
    lure_filter?:
        | 'all'
        | 'expiring_1_days'
        | 'expiring_3_days'
        | 'expiring_7_days'
        | 'expiring_15_days'
        | 'expired'
    purchase_version?: string
    cloud_service_status?: 'all' | 'unknown' | 'normal' | 'expiring' | 'overdue'
    sort_by?:
        | 'status_changed_at'
        | 'last_active_at'
        | 'lure_remind_at'
        | 'created_at'
    sort_order?: 'asc' | 'desc' | 'ascend' | 'descend'
}

export interface DeviceUpdate {
    address?: string
    name?: string
    remark?: string | null
    lng?: number
    lat?: number
    lure_remind_at?: string
    package_key?: DevicePackageKey | string
    purchase_version?: string | null
    installation_image_path?: string | null
    cloud_service_expires_at?: string | null
    type?: number
    region_id?: number | null
    project_id?: number | null
}
